import { useState } from 'react';
import type { CreateAccountUserRoleRequest, CreateAccountUserRoleResponse } from 'vopay';
import { api } from '@/services/api.config';
export default function useCreateUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function createUserRole(
    params: CreateAccountUserRoleRequest,
    bearer?: string,
  ): Promise<CreateAccountUserRoleResponse> {
    try {
      setSubmitting(true);
      const res = await api.postCreateAccountUserRole(params, undefined, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Create account user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, createUserRole };
}
